(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-popup')) {
    class ImagePopup extends HTMLElement {
      connectedCallback() {
        this.key = 'image-popup-' + this.dataset.id;
        this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-close]')) this.close();
          if (e.target.closest('[data-popup-link]')) this.remember();
        });

        if (window.Shopify && Shopify.designMode) {
          this.onSelect = (e) => { if (e.detail.sectionId === this.dataset.id) this.open(); };
          this.onDeselect = (e) => { if (e.detail.sectionId === this.dataset.id) this.close(true); };
          document.addEventListener('shopify:section:select', this.onSelect);
          document.addEventListener('shopify:section:deselect', this.onDeselect);
          return;
        }

        if (!this.shouldShow()) return;
        const delay = parseInt(this.dataset.delay, 10) || 0;
        this.timer = setTimeout(() => this.open(), delay * 1000);

        if (this.dataset.exitIntent === 'true' && matchMedia('(pointer:fine)').matches) {
          this.onLeave = (e) => { if (e.clientY <= 0) this.open(); };
          document.addEventListener('mouseout', this.onLeave);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('keydown', this.onKey);
        if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
        if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:section:deselect', this.onDeselect);
        document.documentElement.style.overflow = '';
      }

      shouldShow() {
        const hours = parseFloat(this.dataset.frequency);
        if (!hours) return true;
        try {
          const last = parseInt(localStorage.getItem(this.key), 10);
          return !last || Date.now() - last > hours * 3600000;
        } catch (e) { return true; }
      }

      remember() {
        try { localStorage.setItem(this.key, String(Date.now())); } catch (e) {}
      }

      open() {
        if (this.isOpen) return;
        this.isOpen = true;
        clearTimeout(this.timer);
        if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
        this.lastFocus = document.activeElement;
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-open'));
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);
        const btn = this.querySelector('.image-popup__close');
        if (btn) btn.focus({ preventScroll: true });
      }

      close(silent) {
        if (!this.isOpen) return;
        this.isOpen = false;
        if (!silent && !(window.Shopify && Shopify.designMode)) this.remember();
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKey);
        setTimeout(() => { this.hidden = true; }, 300);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }
    }
    customElements.define('image-popup', ImagePopup);
  }

  } catch(e) { console.error(e); }
})();
})();
